module.exports = __webpack_public_path__ + "media/images/fbcalls/kraken-f2edebcdd9267e8199d2867011338e71.png";